export const testimonials = [
  {
    quote:
      "A migração do nosso site foi tranquila e o atendimento fez toda a diferença. Em poucos dias tudo estava no ar, mais rápido e estável do que antes.",
    author: "Rafael Muniz",
    role: "Diretor comercial",
    company: "Vale Norte Distribuidora",
    segment: "Distribuição e logística",
  },
  {
    quote:
      "Precisávamos de uma estrutura confiável para o portal de pedidos. A NXHOST entendeu a necessidade e entregou exatamente o que a operação exigia.",
    author: "Carolina Bittencourt",
    role: "Gerente de operações",
    company: "Metalfort Indústria",
    segment: "Indústria metalúrgica",
  },
  {
    quote:
      "Nossa loja virtual ganhou outra cara. Ficou rápida, organizada e pronta para crescer junto com o negócio.",
    author: "Diego Amaral",
    role: "Sócio-fundador",
    company: "Studio Léa",
    segment: "Moda e varejo",
  },
  {
    quote:
      "O suporte responde rápido e fala a nossa língua. Isso faz muita diferença quando o assunto é manter o site da empresa no ar.",
    author: "Patrícia Nogueira",
    role: "Coordenadora de marketing",
    company: "Grupo Andrade Advocacia",
    segment: "Serviços jurídicos",
  },
  {
    quote:
      "Contratamos VPS para um sistema interno e a diferença de desempenho foi imediata. Estrutura sólida e acompanhamento próximo.",
    author: "Marcos Vinícius Reis",
    role: "Diretor de tecnologia",
    company: "Sulmed Saúde",
    segment: "Saúde e serviços",
  },
  {
    quote:
      "Do domínio ao site institucional, tudo foi resolvido em um só lugar. Ganhamos tempo e ficamos com uma presença digital muito mais profissional.",
    author: "Juliana Costa",
    role: "Proprietária",
    company: "Costa & Filhos Contabilidade",
    segment: "Contabilidade",
  },
];